define(
({
  "select_shipping_method": "Välj leveransmetod"
})
);
